import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-58f444c2")

_pushScopeId("data-v-58f444c2")
const _hoisted_1 = { class: "choose-use-container" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_feature_detail = _resolveComponent("feature-detail")
  const _component_choose_user = _resolveComponent("choose-user")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.subscriptionType==='featurePlan')
      ? (_openBlock(), _createBlock(_component_feature_detail, {
          key: 0,
          "user-type": _ctx.userType,
          "project-id": _ctx.projectId,
          onSureDetail: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('sureDetail',$event)))
        }, null, 8, ["user-type", "project-id"]))
      : (_openBlock(), _createBlock(_component_choose_user, {
          key: 1,
          "user-type": _ctx.userType,
          "subscription-type": _ctx.subscriptionType,
          "is-batch": _ctx.isBatch,
          "project-id": _ctx.projectId,
          onSureDetail: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('sureDetail',$event)))
        }, null, 8, ["user-type", "subscription-type", "is-batch", "project-id"]))
  ]))
})